export { SearchTextField as default } from '@disco/shared-components/ui/search-text-field'
